<app-nav-menu></app-nav-menu>
<main class="col-sm-12 main container">
  @if (issuanceloader) {
    <div style="width:100%;top:0;left:0;bottom:0;position:fixed;background:#000000e8;z-index:500;">
      <div class="loaderforPassenger">
        Loading
        <span class="loadspan"></span>
      </div>
    </div>
  }
  <!--<div *ngIf="userService.showSpinner|async" style="width: 100%; height: 105vh; position: fixed; background:#000000e8; z-index: 500; margin-top: -70px; ">
  <div class="loaderforPassenger_forBooking">
    <span class="message">Booking In Process</span>
    <span class="loadspan"></span>
  </div>
</div>-->
<div>
  <ng-template #sweet let-modal>
    <div class="modal-success">
      <img class="sucesspopup" src="assets/img/newsuccess.gif" />
      <h2 class="textpopupsuccess">{{successHeading}}</h2>
      <div class="container-fluid">
        <div class="my-2 pl-2">
          <div class="row col-12"><span class="col-6 text-dark">State:</span><span class="col-6 text-dark"> <b>{{purchaseObj.PurchaseResponse.ProposalState}}</b></span></div>
          <div class="row col-12"><span class="col-6 text-dark">Itinerary ID:</span><span class="col-6 text-dark"><b>{{purchaseObj.PurchaseResponse.ItineraryID}}</b></span></div>
          <div class="row col-12"><span class="col-6 text-dark">Policy No:</span> <span class="col-6 text-dark"><b>{{purchaseObj.PurchaseResponse.PolicyNo}}</b></span></div>
        </div>
        <div class="bg-dark text-light px-2 py-1 my-1">Passenger Details:</div>
        @for (pax of purchaseObj.PurchaseResponse.ConfirmedPassengers; track pax) {
          <div class="pl-2">
            <div class="row col-12"><span class="col-6 text-dark">Name:</span><span class="col-6 text-dark"> <b>{{pax.FirstName}} {{pax.LastName}}</b></span></div>
            <div class="row col-12"><span class="col-6 text-dark">DOB:</span> <span class="col-6 text-dark"><b>{{pax.DOB}}</b></span></div>
            <div class="row col-12"><span class="col-6 text-dark">Identity No:</span> <span class="col-6 text-dark"><b>{{pax.IdentityNo}}</b></span></div>
            <div class="row col-12"><span class="col-6 text-dark">Policy No:</span> <span class="col-6 text-dark"><b>{{pax.PolicyNo}}</b></span></div>
            <div class="row col-12"><span class="col-6 text-dark">Policy Link:</span> <span class="col-6 text-dark"><a href="{{pax.PolicyURLLink}}" target="_blank">Go To Policy</a></span></div>
            <hr />
          </div>
        }
      </div>
      <button class="okButton" (click)="modaldismiss()">OK</button>
    </div>
  </ng-template>
</div>

<!--bad-->
<div>
  <ng-template #bad let-modal>
    <div class="modal-success">
      <img class="sucesspopup" src="assets/img/badicon.gif" />
      <h2 class="textpopupbad">Not Confirmed!</h2>
      <h5 class="textsubheadpopup text-dark">Error Code: <b>{{purchaseObj.PurchaseResponse.ErrorCode}}</b></h5>
      <p class="text-dark">{{purchaseObj.PurchaseResponse.ErrorMessage}}</p>
      <button class="okButton" (click)="modal.dismiss()">Ok</button>
    </div>
  </ng-template>
</div>

<div class="content_container">

  <div class="col-sm-3 right_side right_side_container">
    <div class="solution_card mb-3">
      <div class="hover_color_bubble"></div>
      <div class="so_top_icon">
        <span class="plan-title-in-img">{{selectedPlan.planTitle}}</span>
        <img src="assets/img/trv-1.jpg"  class="plan-img" />

      </div>
      <div class="solu_title" style="text-align:center;">
        <b>Starting from {{selectedPlan.currencyCode}}{{selectedPlan.totalPremiumAmount}}</b>
      </div>
    </div>
    <div class="noti col-sm-12 price_summary">
      <div class="d-flex justify-content-between align-items-center price_summary_children">
        <label class="price_total_label">Departure</label><span class="price_total_tag">{{reqData.fromCountryName}}</span>
      </div>
      <div class="d-flex justify-content-between align-items-center price_summary_children">
        <label class="price_total_label">Arrival</label><span class="price_total_tag">{{reqData.toCountryName}}</span>
      </div>
      <div class="d-flex justify-content-between align-items-center price_summary_children">
        <label class="price_total_label">Start Date</label><span class="price_total_tag">{{reqData.departDateTime}}</span>
      </div>
      <div class="d-flex justify-content-between align-items-center price_summary_children">
        <label class="price_total_label">End Date</label><span class="price_total_tag">{{reqData.returnDateTime}}</span>
      </div>
      <div class="d-flex justify-content-between align-items-center price_summary_children">
        <label class="price_total_label">Base Premium</label><span class="price_total_tag">{{basePremium}}</span>
      </div>
      <div class="d-flex justify-content-between align-items-center price_summary_children">
        <label class="price_total_label">Taxes</label><span class="price_total_tag">{{totalTaxes}}</span>
      </div>
      <div class="d-flex justify-content-between align-items-center price_summary_children">
        <label class="price_total_label">Discount</label><span class="price_total_tag">{{totalDiscount}}</span>
      </div>
      <div class="d-flex justify-content-between align-items-center price_summary_children">
        <label class="price_total_label">Service Fee</label><span class="price_total_tag">{{serviceFees}}</span>
      </div>
      <div class="d-flex justify-content-between align-items-center price_summary_children">
        <label class="price_total_label">VAT</label><span class="price_total_tag">{{vat}}</span>
      </div>
      <div class="d-flex justify-content-between align-items-center price_summary_children">
        <label class="price_total_label" style="font-weight: 800;font-size:12.5px">Total Premium Amount</label><span class="price_total_tag" style="font-weight:800;font-size:12.5px">{{selectedPlan.currencyCode}}{{totalPremiumAmount}}</span>
      </div>
    </div>
  </div>
  <div>

    <form class="noti col-sm-9 form-line-active">
      <div class="insurance-disclaimer">
        <span class="icon">⚠️</span>
        <div class="text">
          <p class="title">Important Notice</p>
          <p class="message">
            The option to put insurance on hold is not available.
            Once you click <strong>Confirm issuance</strong>, the insurance will be issued directly.
          </p>
          <p>Except&nbsp;&nbsp;<b>USA</b> &amp; <b>CANADA</b></p>
        </div>
      </div>

      <div class="form_title">Passenger Information</div>

      <div class="que_travel">Who's Traveling?</div>
      <!--<div class="travel_que-desc">Travelers name must match govt-issued photo ID exactly</div>-->

      @for (obj of issuanceObj.travelInsurancePassengersProperties; track obj; let i = $index) {
        <div class="forms_container_main infant_type">
          <div class="main_form">
            <div class="row py-2 m-0">
              <div class="col-lg-4 col-md-4 col-sm-12 py-2 px-1">
                @if (obj.passengerType == 1) {
                  <div class="detail_title" id="ptype{{i}}">Adult:</div>
                }
                @if (obj.passengerType == 2) {
                  <div class="detail_title">Child:</div>
                }
                @if (obj.passengerType == 3) {
                  <div class="detail_title">Infant:</div>
                }
                @if (obj.passengerType == 1) {
                  <span class="detail_sub-title">12 years or Above</span>
                }
                @if (obj.passengerType == 2) {
                  <span class="detail_sub-title">Less than 12 years</span>
                }
                @if (obj.passengerType == 3) {
                  <span class="detail_sub-title">Less than 2 years</span>
                }
              </div>
              @if (i == 0) {
                <div class="col-lg-4 col-md-4 col-sm-12 px-1">
                  <div class="position-relative">
                    <input class="main_text-box new_main_Text_Box" #ctc [(ngModel)]="mobile" (blur)="getSearchonfocusout(popupsearch,mobile,i)" name="mobile" type="text" id="mobile{{i}}" placeholder="e.g. +971234567890" />
                    <label for="" class="input_lab_first" id="labelmobile{{i}}">Mobile Number</label>
                    <button class="searchButton" id="buttonmobilesearch{{i}}" (click)="SearchCtcNo(popupsearch,mobile,i)" type="button"><span><i class="fas fa-search searchfy"></i></span></button>
                  </div>
                  @if (ValidationChck && !mobile) {
                    <div>
                      <span class="error_class">Phone Required</span>
                    </div>
                  }
                </div>
              }
              <div class="col-lg-4 col-md-4 col-sm-12">
              </div>
              <ng-template #popupsearch let-modal>
                <div class="modal-header">
                  <span class="closepopup" (click)="modal.dismiss()">&times;</span>
                  <h2 class="textpopup">Passenger Profile Details</h2>
                </div>
                <div class="modal-body">
                  <div class="alert alert-danger hiddenclasspstype newpswarn" id="pstypealert" role="alert">
                    Please Select<strong id="warningPsType"></strong>
                  </div>
                  <div id="grids">
                    <dx-data-grid id="grid"
                      [dataSource]="searchprofileCred"
                      [showBorders]="true"
                      [showRowLines]="true">
                      <dxo-selection mode="single"></dxo-selection>
                      <dxo-paging [pageSize]="10"></dxo-paging>
                      <dxo-filter-row [visible]="true"></dxo-filter-row>
                      <dxi-column [visible]="false" dataType="number" dataField="profile_Id" alignment="center"></dxi-column>
                      <dxi-column dataField="title" caption="Title" dataType="string" alignment="center"></dxi-column>
                      <dxi-column dataField="firstName" caption="First Name" dataType="string" alignment="center"></dxi-column>
                      <dxi-column dataField="lastName" caption="Last Name" dataType="string" alignment="center"></dxi-column>
                      <dxi-column dataField="paxGender" [visible]="false" caption="Gender" dataType="string" alignment="center"></dxi-column>
                      <dxi-column dataField="paxDOB" [visible]="false" caption="DOB" dataType="date" alignment="center"></dxi-column>
                      <dxi-column dataField="mobile_No" [visible]="false" caption="Mobile No" dataType="string" alignment="center"></dxi-column>
                      <dxi-column dataField="passportValidTo" caption="Passport Expiry Date" dataType="date" alignment="center"></dxi-column>
                      <dxi-column dataField="passportNumber" caption="Passport No" dataType="string" alignment="center"></dxi-column>
                      <dxi-column dataField="passengerType" [visible]="false" dataType="string" alignment="center"></dxi-column>
                      <dxi-column dataField="passengerTypeName" caption="Passenger Type" dataType="string" alignment="center"></dxi-column>
                      <dxi-column dataField="paxNationality" [visible]="false" caption="Nationality" dataType="string" alignment="center"></dxi-column>
                      <dxi-column dataField="email_Id" [visible]="false" dataType="string" caption="Email" alignment="center"></dxi-column>
                      <dxi-column dataField="frequent_Flyer_No" [visible]="false" caption="Frequent Flyer No" dataType="string" alignment="center"></dxi-column>
                      <dxi-column dataField="countryOfIssuance" caption="Country of Issuance" dataType="string" alignment="center"></dxi-column>
                      <dxi-column caption="Action" [allowSorting]="false" alignment="center" cellTemplate="actionCellTemplate"></dxi-column>
                      <div *dxTemplate="let data of 'actionCellTemplate'">
                        <a class="profilesearchbutton" style="margin-left:10px" (click)="Select_Profiledata(data.data)"><i class="fas fa-check-square"></i> Select</a>
                      </div>
                    </dx-data-grid>
                  </div>
                  <div class="modal-footer">
                  </div>
                </div>
              </ng-template>
            </div>
            <div class="row m-0 py-3">
              <div class="col-sm-2 poisiton_Columns px-1">
                <!--<input class="main_text-box" type="text" placeholder="Mr. , Ms, Dr. etc." [(ngModel)]="obj.title" name="title{{i}}">-->
                <select class="main_text-box title_box" [(ngModel)]="obj.title" id="titles{{i}}" name="title{{i}}" (change)="genderSelectonGivenTitle(i)">
                  @if (obj.passengerType == 1) {
                    <option>
                      Mr
                    </option>
                  }
                  @if (obj.passengerType == 1) {
                    <option>
                      Ms
                    </option>
                  }
                  n>
                  @if (obj.passengerType == 1) {
                    <option>
                      Mrs
                    </option>
                  }
                  @if (obj.passengerType == 2 ||obj.passengerType == 3) {
                    <option>
                      Mstr
                    </option>
                  }
                  @if (obj.passengerType == 2 ||obj.passengerType == 3) {
                    <option>
                      Miss
                    </option>
                  }
                </select>
                <div>
                  <label for="" class="input_lab_first" id="titlelabel{{i}}">Title</label>
                </div>
                @if (ValidationChck && !obj.title) {
                  <div>
                    <span class="error_class">Title Required</span>
                  </div>
                }
              </div>
              <div class="col-sm-4 poisiton_Columns px-1">
                <input class="main_text-box new_main_Text_Box" (blur)="toTitleCase(i,obj.firstName,$event)" [(ngModel)]="obj.firstName" id="firstname{{i}}" name="firstName{{i}}" type="text" />
                <div>
                  <label for="" class="input_lab_first" id="firstlabel{{i}}">First Name</label>
                </div>
                @if (ValidationChck && !obj.firstName) {
                  <div>
                    <span class="error_class">First Name Required</span>
                  </div>
                }
              </div>
              <div class="col-sm-4 poisiton_Columns px-1">
                <input class="main_text-box" type="text" (blur)="toTitleCase(i,obj.lastName,$event)" [(ngModel)]="obj.lastName" id="lastname{{i}}" name="lastName{{i}}">
                <div>
                  <label for="" class="input_lab_first" id="lastlabel{{i}}">Last Name</label>
                </div>
                @if (ValidationChck && !obj.lastName) {
                  <div>
                    <span class="error_class">Last Name Required</span>
                  </div>
                }
              </div>
              <div class="col-sm-2 poisiton_Columns px-1">
                <!--<input class="main_text-box" type="text" placeholder="Mr. , Ms, Dr. etc." [(ngModel)]="obj.title" name="title{{i}}">-->
                <select class="main_text-box title_box " [(ngModel)]="obj.gender" id="gender{{i}}" name="gender{{i}}">
                  <option id="male{{i}}">
                    Male
                  </option>
                  <option id="female{{i}}">
                    Female
                  </option>
                </select>
                <div>
                  <label for="" class="input_lab_first" id="genderlabel{{i}}">Gender</label>
                </div>
                @if (ValidationChck && !obj.gender) {
                  <div>
                    <span class="error_class">Gender Required</span>
                  </div>
                }
              </div>
            </div>
            <div class="row m-0 py-3">
              <div class="col-sm-3 pb-2 px-1">
                <input class="main_text-box " type="text" [(ngModel)]="obj.passportNumber" id="passportnum{{i}}" name="passportNumber{{i}}">
                <div>
                  <label for="" class="input_lab_first" id="ppnlabel{{i}}">Passport No</label>
                </div>
                @if (ValidationChck && !obj.passportNumber) {
                  <div>
                    <span class="error_class">Passport Number Required</span>
                  </div>
                }
              </div>
              <div class="col-sm-3 pb-2 px-1">
                <input class="main_text-box dob_input" type="date" [max]="today" [(ngModel)]="obj.dateOfBirth" name="dateOfBirth{{i}}" id="dob_input{{i}}">
                <div>
                  <label for="" class="input_lab_first" id="doblabel{{i}}">Date of Birth</label>
                </div>
                @if (ValidationChck && !obj.dateOfBirth) {
                  <div>
                    <span class="error_class">DOB Required</span>
                  </div>
                }
              </div>
              <div class="col-sm-2 pb-2 px-1">
                <input class="main_text-box " type="text" [(ngModel)]="obj.age" id="age{{i}}" name="age{{i}}">
                <div>
                  <label for="" class="input_lab_first" id="agelabel{{i}}">Age</label>
                </div>
                @if (ValidationChck && !obj.age) {
                  <div>
                    <span class="error_class">Age Required</span>
                  </div>
                }
              </div>
              <div class="col-sm-4 px-1">
                <ng-select class="nationalityClass"
                  id="nationcc{{i}}"
                  [items]="countryList"
                  placeholder="Select"
                  bindLabel="countryName" bindValue="code"
                  [searchable]="true"
                  (click)="Nation_Focus(i)"
                  (blur)="Coi_Focus(i)"
                  [ngModelOptions]="{standalone: true}"
                  [(ngModel)]="obj.nationality">
                </ng-select>
                <div>
                  <label for="" class="input_lab_first" id="nationLabel{{i}}">Nationality</label>
                </div>
                @if (ValidationChck && !obj.nationality) {
                  <div>
                    <span class="error_class">Nationality Required</span>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }

      <div class="main_form">
        <div class="que_travel mb-3">Passenger Contact Details</div>
        <div class="row">
          <div class="col-lg-5 col-md-5 col-sm-12">
            <div class="col-12 px-1 mt-4">
              <input class="main_text-box" type="text" [(ngModel)]="email" id="email" name="email">
              <div>
                <label for="email" class="input_lab_first" id="emaillabel">Email</label>
              </div>
              @if (ValidationChck && !email) {
                <div>
                  <span class="error_class">Email Required</span>
                </div>
              }
            </div>
          </div>
          <div class="col-lg-5 col-md-5 col-sm-12">
            <div class="col-lg-12 col-md-12 col-sm-12 px-1 mt-4">
              <div class="search newsearxhfocus">
                <input class="main_text-boxs" [(ngModel)]="PNR" name="PNR" type="text" id="PNR" />
                <label for="PNR" class="input_lab_search" id="labelpnr">PNR</label>
              </div>
              @if (ValidationChck && !PNR) {
                <div>
                  <span class="error_class">PNR Required</span>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="main_form">
        <div class="que_travel">Rules & Restrictions</div>
        <div class="que_line"></div>
        <div class="rules_headings"><i class="uil uil-circle rules_icon"></i>Kindely Check the spelling & reconfirm the passenger name(s) before you book.</div>
        <div class="rules_headings"><i class="uil uil-circle rules_icon"></i>Ticket name changes are not permitted once issued.</div>
        <h3 class="rules_desc">The above mentioned purchases are non-transferable and name changes not permitted.</h3>
        <div class="rules_footer">
          <div class="checkBox">
            <input type="checkbox" [(ngModel)]="agreed" [ngModelOptions]="{standalone: true}" (change)="active()" />
            <div class="accept">I accept the Terms & Conditions.</div>
          </div>
          <div class="rules_buttons">
            <button class="cancelButton" (click)="goBackToResults()"><i class="fas fa-angle-double-left"></i> Back</button>
            <button class="sendButton" [disabled]="buttonagreed" (click)="IssuanceSubmit(sweet,bad)">Confirm Issuance <i class="fas fa-angle-double-right"></i></button>
            <div id="response-screen" style="margin-top:15px;text-align:center;font-size:1.2rem;font-weight:bold"></div>

          </div>
        </div>
      </div>
    </form>
  </div>

</div>
</main>

